import React from 'react'
import { message } from 'antd';
import {WWTable} from "@/globalComponents"
import { WWMethods } from '@/tools';
import { WWUtils } from '../../../tools';
export default class DeviceDirectiveRecord extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            directiveList:[],
            imei:'',
            currentPage:1,
            pageSize:10,
            count:0
        };
        this.handleDirectiveListChange = this.handleDirectiveListChange.bind(this);
        window.getDeviceRecord = this.getDeviceRecord.bind(this);
        this.formatParams = this.formatParams.bind(this);
        this.getImeiDirectiveList = this.getImeiDirectiveList.bind(this);
    }

    componentDidMount() {
        if (this.props.record) {
            this.setState({
                imei: this.props.record.imei
            }, () => {
                if(!this.props.refreshDirective) {
                    this.getDeviceRecord();
                }
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.record) {
            if (nextProps.record.imei !== this.state.imei) {
                this.setState({
                    imei: nextProps.record.imei
                }, () => {
                    this.getDeviceRecord();
                })
            }
        }
    }
    formatParams(){
        const {imei,currentPage,pageSize} = this.state;
        return   {
            imei,
            currentPage,
            pageSize
        }
    }
    //指令记录数量统计
    getDeviceRecord() {
        const {imei} = this.state;
        let that = this;
        if (!imei) {
            return;
        }
        WWMethods.getImeiDirectiveCount(that.formatParams(),(data)=>{
            that.setState({
                loading: false
            });
            if(data.code === 0){
                that.setState({
                    count:data.data
                },()=>{
                    that.getImeiDirectiveList()
                })
            }
        })
    }
    //指令记录
    getImeiDirectiveList(){
        let that = this;
        WWMethods.getImeiDirectiveList(that.formatParams(),(data)=>{
            if(data.code === 0){
                if(data && data.data instanceof Array) {
                    data.data.forEach(function (item, index) {
                        item.serialNumber = index + 1;
                        if (item.sendPlatform == 1  ) {
                            item.platformType = 'WEB';
                        } else if (item.sendPlatform == 2 || item.sendPlatform == 5) {
                            item.platformType = 'APP';
                        }else if (item.sendPlatform == 3) {
                            item.platformType = 'API';
                        }else if (item.sendPlatform == 6) {
                            item.platformType = 'IMEI';
                        }else if (item.sendPlatform == 4) {
                            item.platformType = 'Wechat Mini APP';
                        }
                    });
                    that.setState({
                        directiveList:data.data,
                    });
                }
            }
        })
    }

    handleDirectiveListChange(current,pageSize) {
        this.setState({
            currentPage:current,
            pageSize
        },()=>{
            this.getDeviceRecord();
        })
    }

    render() {
        const {directiveList,currentPage,pageSize,count} = this.state;
        const columns = [ {
            title: Strings.directiveName || "指令名称",
            dataIndex: 'instructionName',
            width:'10%'
        }, {
            title: Strings.request || "指令内容",
            dataIndex: 'request',
            width:'20%'
        }, {
            title:Strings.directiveStatusName || "指令状态",
            dataIndex: 'statusName',
            width:'8%'
        }, {
            title: Strings.sendTime || "发送时间",
            dataIndex: 'sendTime',
            width:'10%',
            render:(text,record)=>{
                return WWUtils.formatTimeYMDHms(text);
            }
        }, {
            title: Strings.response || "回复",
            dataIndex: 'response',
            width:'20%',

        }, {
            title: Strings.rs10161 || Strings.responseTime || "回复时间",
            dataIndex: 'responseTime',
            width:'10%',
            render:(text,record)=>{
                return WWUtils.formatTimeYMDHms(text);
            }
        }, {
            title: Strings.senderName || "下发人",
            dataIndex: 'senderName',
            width:'10%',
            render:(text,record)=>{
                return text? text : "";

            }
        }, {
            title: Strings.platformType || "平台",
            dataIndex: 'platformType',
            width:'8%',
        }];
        return (
            <div className='' style={{marginTop:0}}>
                <WWTable className="new_app_table"
                         dataSource={directiveList}
                         columns={columns}
                         pagination={false}
                         bordered={false}
                         count={count}
                         innerHeight={this.props.maxH-120}
                         pageSize={pageSize}
                         currentPage={currentPage}
                         onChange={this.handleDirectiveListChange}
                         onShowSizeChange={(currentPage,pageSize)=>{
                            this.handleDirectiveListChange(1,pageSize)
                          }}
                        />
            </div>
        )
    }
}
